module.exports = __webpack_public_path__ + "img/32400.9ae4d19b.jpg";